import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch(
        'https://readdy.ai/api/form/d9rflbknlsngrm4lmbi0',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(
            Object.fromEntries(
              Array.from(formData.entries()).filter(
                ([key]) => key !== 'phone_alt'
              ) as [string, string][]
            )
          ).toString(),
        }
      );

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！您已成功加入开云足球资讯推送。');
        setEmail('');
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || responseText || '订阅失败';
        if (
          typeof serverMsg === 'string' &&
          (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))
        ) {
          setStatus('success');
          setMessage('感谢订阅！');
          setEmail('');
        } else {
          setStatus('error');
          setMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后重试');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50 border-t border-background-200">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5">
          <i className="ri-mail-send-line text-xl"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
          订阅开云足球资讯
        </h2>
        <p className="text-foreground-500 text-sm mb-6">
          第一时间获取最新赛事资讯、独家分析与专属活动福利
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="phone_alt"
            autoComplete="off"
            tabIndex={-1}
            readOnly
            aria-hidden="true"
            className="form-honeypot"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap disabled:opacity-50"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-primary-600 text-sm">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-red-500 text-sm">{message}</p>
        )}
      </div>
    </section>
  );
}